import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/skills/id/connections/page';

export const Route = createFileRoute('/_app/_chat/skills/$id/connections/')({
  component: Page,
});
